module.exports = __webpack_public_path__ + "assets/60d157a2fc447a4a0b1c4fd4eca18e22.jpg";